"use client";

import { LegalLinks } from "oddsgate-ds";

type LegalLinkItemAttrs = {
  title?: string;
  linkType?: string;
  url?: string;
  fileUrl?: string;
  className?: string;
  style?: Record<string, unknown>;
};

type LegalLinkItem = {
  blockName: string;
  attrs: LegalLinkItemAttrs;
  innerBlocks: any[];
};

export type IBlockLegalLinks = {
  attrs: {
    anchor?: string;
    variant?: string;
    className?: string;
    style?: Record<string, unknown>;
  };
  innerBlocks: LegalLinkItem[];
};

export default function BlockLegalLinks({ attrs, innerBlocks }: IBlockLegalLinks) {
  // Transform innerBlocks data to the format expected by LegalLinks component
  const links = innerBlocks.map(block => {
    const { attrs } = block;
    const { title, linkType, url, fileUrl } = attrs;
    
    // Determine the URL based on linkType
    const linkUrl = linkType === 'file' ? fileUrl : url;
    
    return {
      label: title || '',
      url: linkUrl || ''
    };
  });

  return (
    <div className={attrs.className || ''} id={attrs.anchor || undefined}>
      <LegalLinks links={links} />
    </div>
  );
}